import { List } from "immutable";

/**
 * Splits a List<T> into two List<T>'s based on the given predicate
 *
 * @param list - List of elements to be partitions based on predicate
 * @param predicate - Predicate that determines if a given element is placed in the first or second partition
 * @returns An array whose first element contains a List<T> for which `predicate` is true and the second element a List<T> for which `predicate` is false
 */

export const partition = <T>(list: List<T>, predicate: (element: T) => boolean): [List<T>, List<T>] => list.reduce(([predicateTrue, predicateFalse], element) => {
  return predicate(element)
    ? [predicateTrue.push(element), predicateFalse]
    : [predicateTrue, predicateFalse.push(element)];
}, [List<T>(), List<T>()]);
